export const detectCoeff = (coeffs: any, activeRows: any, activeRisk: string, setcoeffs: any) => {
    if (coeffs) {
        if (coeffs[+activeRows - 8]) {
            setcoeffs(coeffs[+activeRows - 8][activeRisk.toLowerCase()]);
        }
    }
}